// The reader's light or dark choice: public/theme.js applies it before the first paint; this
// switches it and remembers the choice.
import { useState } from "react";

export type Theme = "light" | "dark";

export function currentTheme(): Theme {
  return document.documentElement.getAttribute("data-theme") === "dark" ? "dark" : "light";
}

export function useTheme(): [Theme, () => void] {
  const [theme, setTheme] = useState<Theme>(currentTheme);
  const toggle = () => {
    const next: Theme = theme === "dark" ? "light" : "dark";
    document.documentElement.setAttribute("data-theme", next);
    try {
      localStorage.setItem("ocs-theme", next);
    } catch {
      // Storage refused (private mode): the choice lasts this page only.
    }
    setTheme(next);
  };
  return [theme, toggle];
}
